/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable import/no-cycle */

import { defineModule } from 'direct-vuex';
import { ApplicationData, ScoreClassDefinition } from '@/types';
import { moduleGetterContext } from '@/store';
import { getDarkTheme, setDarkTheme } from '@/utils/storage';

const preferredStudyType = 'pain-mgs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// const applicationActionContext = ((context: any) => moduleActionContext(context, applicationModule));
const applicationGetterContext = (
  (args: [unknown, unknown, unknown, unknown]) => moduleGetterContext(args, applicationModule)
);

const applicationModule = defineModule({
  namespaced: true,
  state: {
    applicationData: null as ApplicationData | null,
    selectedStudyType: preferredStudyType,
    showDataConsole: false,
    latestAddedTaskId: null as string | null,
    darkTheme: getDarkTheme(),
    dialogOpen: false,
  },
  getters: {
    subjectTypes(...args): string[] {
      const { state } = applicationGetterContext(args);
      if (state.applicationData === null) { return []; }

      return state.applicationData.lists.subject_types;
    },
    studyTypes(...args): string[] {
      const { state } = applicationGetterContext(args);
      if (state.applicationData === null) { return []; }

      return state.applicationData.lists.study_types;
    },
    scoreClasses(...args): ScoreClassDefinition[] | null {
      const { state, rootGetters } = applicationGetterContext(args);
      const studyType = state.selectedStudyType;
      const { subjectType } = rootGetters.dataset;

      if (state.applicationData === null || subjectType === null) return null;
      return state.applicationData.subject_templates[subjectType][studyType].scores;
    },
    annotationClasses(...args): string[] | null {
      const { state, rootGetters } = applicationGetterContext(args);
      const studyType = state.selectedStudyType;
      const { subjectType } = rootGetters.dataset;

      if (state.applicationData === null || subjectType === null) return null;
      return state.applicationData.subject_templates[subjectType][studyType].annotations.map(
        (annEntry) => annEntry.class,
      );
    },
  },
  mutations: {
    setApplicationData(state, data: ApplicationData) {
      state.applicationData = data;
    },
    setSelectedStudyType(state, studyType: string) {
      state.selectedStudyType = studyType;
    },
    setShowDataConsole(state, show: boolean) {
      state.showDataConsole = show;
    },
    setLatestAddedTaskId(state, task_id: string) {
      state.latestAddedTaskId = task_id;
    },
    setDarkTheme(state, payload: boolean) {
      state.darkTheme = payload;

      // Not sure if this is kosher
      setDarkTheme(payload);
    },
    setDialogOpen(state, data: boolean) {
      state.dialogOpen = data;
    },
  },
  actions: {},
});

export default applicationModule;
